module.exports = __webpack_public_path__ + "img/update-icon01.png";